<template>
  <div class="demo-grid" id="registerPage">  
    <XR-head titleText="注册" :rightShow="false" ref="head"></XR-head>
     <img :src='siteConfig.MobileBgImage' class="loginbg" />
    <!-- <mu-tabs :value="activeTab" @change="handleTabChange">
      <mu-tab value="mobile" title="手机号注册"/>
      <mu-tab value="email" title="邮箱注册"/>
    </mu-tabs> -->
    <div class="mu-tabs">
        <button class="mu-tab-link mu-tab-active"  type="button" >
          <div class="">
            <div class="mu-tab-text">手机号注册</div>
          </div>
        </button> 
    </div>
    <!--<div class="mu-tabs">
      <button class="mu-tab-link" :class="this.activeTab=='mobile'?'mu-tab-active':' '" type="button" @click="handleTabChange('mobile')">
        <div class="">
          <div class="mu-tab-text">手机号注册</div>
        </div>
      </button> 
      <button class="mu-tab-link" :class="this.activeTab=='email'?'mu-tab-active':' '" type="button"  @click="handleTabChange('email')">
        <div class="">
            <div class="mu-tab-text">邮箱注册</div>
        </div>
      </button>
      <div class="tab-link">
        <span class="mu-tab-link-highlight" ></span>
      </div>
      
    </div>-->

    <div class="login-form">
      <template v-if="activeTab == 'mobile'">
        <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="33">
            <mu-text-field label="手机号" type="number" helpText="请输入手机号" icon=":fa fa-mobile" labelFloat fullWidth v-model="registerInfo.Mobile" />
          </mu-col>
        </mu-row>
        <!-- <mu-row gutter>
          <mu-col width="70" tablet="75" desktop="33">
            <mu-text-field label="图形验证" helpText="点击右侧按钮获取，3分钟内有效" icon=":fa fa-msg4" labelFloat fullWidth v-model="registerInfo.SmsCode"  />
          </mu-col>
          <mu-col width="30" tablet="25" desktop="33">      
            <img :src="MOBILE_URL+'/validateCode.aspx?mobile=3213219890'" class="sms-button" @click="getSmsCode()"/>   
          </mu-col>
        </mu-row> -->
        <mu-row gutter>
          <mu-col width="70" tablet="75" desktop="33">
            <mu-text-field label="验证码" helpText="点击右侧按钮获取，3分钟内有效" icon=":fa fa-xinxi" labelFloat fullWidth v-model="registerInfo.SmsCode"  />
          </mu-col>
          <mu-col width="30" tablet="25" desktop="33">      
            <mu-raised-button :label="smsBtnText" class="sms-button" @click="getSmsCode()" secondary/>   
          </mu-col>
        </mu-row>
      </template>
      <template v-if="activeTab == 'email'">        
        <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="33">
            <mu-text-field label="邮箱" helpText="请输入邮箱地址" icon=":fa fa-envelope-o" labelFloat fullWidth v-model="registerInfo.Email" />
          </mu-col>
        </mu-row>
        <mu-row gutter>
          <mu-col width="70" tablet="75" desktop="33">
            <mu-text-field label="验证码" helpText="点击右侧按钮获取，3分钟内有效" icon=":fa fa-xinxi" labelFloat fullWidth v-model="registerInfo.Code" />
          </mu-col>
          <mu-col width="30" tablet="25" desktop="33">      
            <mu-raised-button :label="emailBtnText" class="sms-button" @click="getEmailCode()" secondary/>   
          </mu-col>
        </mu-row>
      </template>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33">
          <mu-text-field label="密码" type="password" helpText="请输入密码" icon=":fa fa-lock" labelFloat fullWidth v-model="registerInfo.Password" />
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33">
          <mu-text-field label="确认密码" type="password" helpText="请再次输入密码" icon=":fa fa-lock" labelFloat fullWidth v-model="registerInfo.ConfrimPassword" />
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33">
          <mu-text-field label="邀请码" helpText="请输入推荐人的邀请码" icon=":fa fa-salesman2" v-if="!this.isRecommend" labelFloat fullWidth v-model="registerInfo.Recommend" />
          <mu-text-field label="邀请码" helpText="推荐人的邀请码" icon=":fa fa-salesman2" disabled v-if="this.isRecommend" labelFloat fullWidth v-model="BindRecommendUserName" />
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33" class="login-div">
          <mu-raised-button label="注 册" class="demo-raised-button" primary fullWidth @click="Register()" />
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33" class="div3">
          <XR-toast ref="XRtoast"></XR-toast>
        </mu-col>
      </mu-row>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5'
import GUID from '../util/guid'
import UserCache from '../util/cache'
export default {
  data () {
    return {
      activeTab: 'mobile',       
      smsBtnText:'点击获取',
      isSms:false,
      emailBtnText:'点击获取',
      isRecommend:false,//是否已绑定推荐人
      BindRecommendUserName: '', //已绑定推荐人的邀请码
      isEmail:false,
      registerInfo:{
        RequestId:'',
        Mobile:'',
        Email:'',
        SmsCode:'',
        Code:'',
        Password:'',
        ConfrimPassword:'',
        PromotionMethod:5,
        Recommend:'',
        IsWeiXin:'0',
        WeChat:{
          openid:''        
        }
      },
      siteConfig:{ MobileBgImage : '' }
    }
  },
  mounted : function(){
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });

    
    

    let ua = navigator.userAgent.toLowerCase()
    if(this.isWeixinBrowser(ua)){
      this.registerInfo.WeChat.openid = this.$store.state.wechat.WeChatInfo
      this.registerInfo.IsWeiXin = '1'
      this.registerInfo.PromotionMethod = '4'
      //alert("微信浏览器：openid="+ this.registerInfo.WeChat.openid)

      var source_username = window.localStorage.source_username;
      if (source_username){
        this.isRecommend = false;
        this.registerInfo.Recommend = source_username;
      } else {
        this.GetRecommend()
      }      
    }else{
      //alert("不是微信浏览器")
    }
    this.getSiteInfo()
  },
  methods: {
    getSiteInfo: function () {
      const ths = this;
      this.$post('/Shop/SiteConfigServer/GetSiteConfig')
          .then(function (res) {
          if(res.IsSuccess){
              ths.siteConfig = res.Data
              console.log(ths.siteConfig)
          }
      })
      .catch(function (err) {
          console.log(err)
      })    
    },   
    isWeixinBrowser(ua) {
      return (/micromessenger/.test(ua)) ? true : false;
    },
    handleTabChange(val){
      this.activeTab = val
      if(this.activeTab=='email'){
        this.$el.querySelector('.tab-link').style.transform= 'translate3d(100%, 0px, 0px)'
      }else{
        this.$el.querySelector('.tab-link').style.transform= 'translate3d(0px, 0px, 0px)'
      }
    },
    GetRecommend:function(){
      var ths = this
      this.$post('/Shop/UserServer/GetRecommendUserNameByOpenId', {'openid': this.registerInfo.WeChat.openid})
        .then(function (res) { 
            if(res.IsSuccess){
              ths.isRecommend = true
              ths.BindRecommendUserName = res.Data      
            }
            else{
              //ths.$refs.XRtoast.failed(res.Msg,true)    
            }  
        })
        .catch(function (err) {
          console.log(err)
        })      
    },
    Register: function () {
      const ths = this

      var url = '/Shop/UserServer/PhoneRegister'
      if(this.activeTab == 'mobile'){
        if(!this.registerInfo.Mobile){
          ths.$refs.XRtoast.failed('请输入手机号' ,true)   
          return
        }
        if(!this.registerInfo.SmsCode){
          ths.$refs.XRtoast.failed('请输入验证码' ,true)   
          return
        }
      }
      else{
        url = '/Shop/UserServer/EmailRegister'
        if(!this.registerInfo.Email){
          ths.$refs.XRtoast.failed('请输入邮箱' ,true)   
          return
        }
        if(!this.registerInfo.Code){
          ths.$refs.XRtoast.failed('请输入验证码' ,true)   
          return
        }
      }
      if(!this.registerInfo.Password){
        ths.$refs.XRtoast.failed('请输入密码' ,true)   
        return
      }
      if(!this.registerInfo.ConfrimPassword){
        ths.$refs.XRtoast.failed('请输入确认密码' ,true)   
        return
      }
      
      this.$post(url, JSON.stringify(this.registerInfo))
        .then(function (res) { 
            if(res.IsSuccess){
              ths.$refs.XRtoast.success(res.Msg)   
              
              if(ths.isRemember){
                window.localStorage['XRLoginRememberUserName'] = json.username
              }else{
                window.localStorage.removeItem('XRLoginRememberUserName')
              }
              
              if(!res.Data.HeadPic){
                res.Data.HeadPic = 'http://frontend.xurigo.com/icon/person.jpg'
              }
              
              ths.$store.dispatch('SetUser', res.Data.SessionId)
              
              var redirect = ths.$route.query.redirect
              if(!redirect){
                redirect = "/usercenter/index"
              }              
              ths.$router.push(redirect)
            }
            else{
              ths.$refs.XRtoast.failed(res.Msg,true)    
            }  
        })
        .catch(function (err) {
          console.log(err)
        })      
    },
    
    getSmsCode: function(){
      const ths = this;
      if(!ths.isSms){
        ths.$refs.XRtoast.load("正在处理...")
        this.$post('/Shop/UserServer/PhoneRegisterSendCode',JSON.stringify({ requestId: this.registerInfo.RequestId, mobile:this.registerInfo.Mobile}))
          .then(function (res) {
            ths.$refs.XRtoast.hide()
            if(res.IsSuccess){
              ths.isSms = true
              ths.smsBtnText = res.Data * 60;
              var interval = setInterval(function(){
                if(ths.smsBtnText >0){
                  ths.smsBtnText--
                  ths.isSms = true
                }else{
                  ths.isSms = false
                  ths.smsBtnText = '点击获取'
                  clearInterval(interval)
                }
              }, 1000)  
            }else{
              ths.$refs.XRtoast.failed(res.Msg, true)            
            }
        })
        .catch(function (err) {
          console.log(err)
        })
      }
    },
    getEmailCode: function(){
      const ths = this;
      if(!ths.isEmail){
        ths.$refs.XRtoast.load("正在处理...")
        this.$post('/Shop/UserServer/EmailRegisterSendCode',JSON.stringify({email:this.registerInfo.Email}))
          .then(function (res) {
            ths.$refs.XRtoast.hide()
            if(res.IsSuccess){
              ths.isEmail = true
              ths.emailBtnText = res.Data * 60;
              var interval = setInterval(function(){
                if(ths.emailBtnText >0){
                  ths.emailBtnText--
                  ths.isEmail = true
                }else{
                  ths.isEmail = false
                  ths.emailBtnText = '点击获取'
                  clearInterval(interval)
                }
              }, 1000)  
            }else{
              ths.$refs.XRtoast.failed(res.Msg, true)            
            }
          })
          .catch(function (err) {
            console.log(err)
          })
      }
    }
  },
  watch:{
    isRemember(val){      
      if(val){
        window.localStorage['XRLoginIsRememberUserName'] = true
      }else{
        window.localStorage.removeItem('XRLoginIsRememberUserName')
      }
      this.isRemember =val
    }    
  }
}

</script>
<style>
#registerPage{  
  background: #eee;
  bottom: 0;
}
#registerPage .mu-appbar{
  background: rgba(100,100,100,0.2);
  position: fixed;
  top: 0;
}
#registerPage .mu-tabs{
    position: absolute;
    top: 66px;
    width: 90%;
    left: 0;
    right: 0;
    margin: 0 auto;
    background: none;
    color: #fff;
}
#registerPage .mu-tabs .tab-link{
    position: absolute;
    height: 3px;
    bottom: 0;
    display: block;
    transition: 0.5s;
    width: 50%;
    left: 0;
}
#registerPage .mu-tabs .mu-tab-link.mu-tab-active .mu-tab-text
{
  color: #fff;
}
#registerPage .mu-tabs .mu-tab-link .mu-tab-text
{
  color: #ccc;
}
#registerPage .mu-tabs .tab-link .mu-tab-link-highlight{
    width: 50px;
    background: #fff;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    
}
#registerPage .mu-tabs .mu-tab-link{
  color: #fff;
}
#registerPage .loginbg {
  width: 100%;
  display: block;
}
#registerPage .login-form {
  padding: 10px 20px 20px 10px;
  padding-bottom: 56px;
  background: white;
  position: absolute;
  top: 134px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 95%;
  border-radius: 10px 10px;
}
#registerPage .login-div {
  padding: 40px 0px 0 20px;
}
#registerPage .demo-raised-button {
  height: 50px;
  background: #ff4981;
}
#registerPage .div2 {
  padding: 20px 0 0 0;
}
#registerPage .demo-flat-button.right {
  float: right;
}
#registerPage .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}
#registerPage .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}
#registerPage .login-form .fa-mobile{
  font-size: 30px;
}
#registerPage .login-form .fa-envelope-o{
  font-size: 20px;
}
#registerPage .login-form .fa-xinxi{
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/pages/Register.vue